// extracted by mini-css-extract-plugin
module.exports = {"desktop":"styles_desktop__ibtqt","left":"styles_left__30-9J","menuBody":"styles_menuBody__2pWVI","right":"styles_right__1KZVD","mobile":"styles_mobile__2U64N"};